import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkUploadObTagsActions from "../../store/actions/BulkUploadObTags";

const instructions = [
    "Please provide data as per the format in the sample file.",
    "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
    "please avoid duplicate entries",
    "start_time and end_time should be in the format: YYYY-MM-DD HH:MM:SS",
];

const BulkUploadObTagsDashboard = ({ getBulkUploadUrl }) => {
    return (
        <BulkUploadFile
            instructions={instructions}
            btnDataTestID="BulkUploadObTagsBtn"
            uploadUrl="/upload-doc/ack"
            sampleURL="/sample/bulk_upload_ob_tags.csv"
            id="BulkUploadObTagsModal"
            sendExtraAck={true}
            keyName="callback_key"
            heading="Bulk Upload Ob Tags"
            getUploadUrl={getBulkUploadUrl}
            action="assign_tags"
            serviceOwner="ONBOARDING_SERVICE"
            useUserUploadedFilename={true}
            validationType={"BulkUploadObTags"}
            addTimestampToFileName={true}
            acceptedFileFormat=".csv"
        />
    );
};

function mapDispatchToProps(dispatch) {
    return {
        getBulkUploadUrl: bindActionCreators(
            BulkUploadObTagsActions.getUploadUrl,
            dispatch
        ),
    };
}

export default connect(null, mapDispatchToProps)(BulkUploadObTagsDashboard);
